<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-row style="margin-bottom:10px;">
      <a-button type="primary" @click="bindProData">绑定商品</a-button>
    </a-row>
    <search-page-view
      ref="table"
      rowKey="proId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="action" slot-scope="data">
        <a-popconfirm
          title="是否要删除当前绑定商品？"
          @confirm="deleteEvent(data.record)">
          <a>删除绑定</a>
        </a-popconfirm>
      </div>
    </search-page-view>
    <a-modal title="商品绑定" :visible="dialogVisible" width="650px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="所属供应商" prop="providerId">
          <a-select allowClear v-model="ruleForm.providerId" placeholder="请选择">
            <a-select-option v-for="item in supplierList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" prop="proId">
          <a-button type="primary" @click="showSelectedDialog = true">选择商品</a-button>
          <span v-if="ruleForm.proId">&nbsp;&nbsp;商品ID:{{ ruleForm.proId }}</span>
          <span>&nbsp;&nbsp;*仅能关联抢购类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item label="供应商商品编号" prop="dealId">
          <a-input placeholder="供应商商品编号" v-model="ruleForm.dealId" :maxLength="25"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      params-path="api/product/getProPreSaleList"
      base-key="apiUrl"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item
        label="商品ID"
        slot="search_proId" v-bind="currentDialogLayout">
        <a-input
          v-model="selectedQueryParams.proId"
          style="width: 170px"
          placeholder="请输入商品ID"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="商品名称"
        slot="search_proName"
        v-bind="currentDialogLayout">
        <a-input
          v-model="selectedQueryParams.searchName"
          style="width: 170px"
          placeholder="请输入商品名称"
        ></a-input>
      </a-form-item>
      <template slot="proCatalogId" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'RewardBindPro',
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      submitLoading: false,
      showSelectedDialog: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      selectedQueryParams: {
        searchName: '',
        proId: ''
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      supplierList: [],
      ruleForm: {
        dealId: '',//第三方商品编号 ,
        id: '',// id ,
        proId: '',//商品ID,关联pro_t_info
        providerId: undefined//关联账号Id(供应商),关联airline_t_provider
      },
      rules: {
        providerId: [
          { required: true, message: '所属供应商', trigger: 'change' }
        ],
        proId: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
        dealId: [
          { required: true, message: '请输入供应商商品编号', trigger: 'blur' }
        ]
      },
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '38%'
        },
        {
          title: '类型',
          dataIndex: 'catalogName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'providerName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dialogVisible: false,
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'RewardBindPro', title: '商品绑定' },
      { name: 'zhRewardOrder', title: '订单直连' },
      { name: 'RelevanceAccount', title: '关联账号' }
    ])
  },
  methods: {
    bindProData() {
      this.dialogVisible = true
      this.getSupplierList()
    },
    getSupplierList() {
      this.getHttpServices().getProService().post('airlineProvider/getAirlineProviderVoList').then(res => {
        this.getLogUtils().logWithTag('getSupplierList', res)
        this.supplierList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proCatalogId',
          width: '100px',
          scopedSlots: { customRender: 'proCatalogId' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    // 删除绑定
    deleteEvent(data) {
      this.getLogUtils().logWithTag('deleteEvent', data)
      this.getHttpServices().getProService().post('airlineProduct/delProductInfo/' + data.id, {}).then(res => {
        this.getLogUtils().logWithTag('deleteEvent', res)
        this.$message.success('删除绑定商品成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 选择商品
    onSelectedResult(data) {
      this.getLogUtils().logWithTag('onSelectedResult', data)
      this.ruleForm.proId = data.proId
      this.showSelectedDialog = false
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('airlineProduct/getAirlineProductVoPage', params)
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getProService().post('airlineProduct/editAirlineProduct', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('绑定商品成功')
        this.dialogVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style scoped lang="less">

</style>